import { User } from '@/types'
import axios from 'axios'
import { useEffect } from 'react'

type SentryInitializationProps = { user?: User | null }

const SentryInitialization = ({ user }: SentryInitializationProps) => {
  useEffect(() => {
    if (window.location.hostname !== 'localhost') {
      import('@sentry/react').then((Sentry) => {
        if (!Sentry.getClient()) {
          Sentry.init({
            dsn: `https://a2bc5037b4ae6ee6b51e4661a61e36c4@o4507260359540736.ingest.de.sentry.io/${process.env.REACT_APP_SENTRY_ID}`,
            beforeSend(event, hint) {
              const error = hint.originalException

              // Ignore Axios 401 errors
              if (axios.isAxiosError(error) && error.response?.status === 401) {
                return null
              }

              // ignore network errors (no response at all)
              if (axios.isAxiosError(error) && !error.response) return null

              return event
            },
            environment: process.env.REACT_APP_ENVIRONMENT ?? 'development',
            release: `upseat-ui@${process.env.REACT_APP_VERSION}`,
            ignoreErrors: [
              "Can't find variable: logMutedMessage",
              'unidentified runtime error',
            ],
          })
        }

        // Set separately from init so anonymous sessions (deep links) still report.
        Sentry.setUser(user ? { id: user.uid, email: user.email } : null)
      })
    }
  }, [user])

  return null
}

export default SentryInitialization
